import { FC } from "react";

import { DamagedProductTicketSuccessModal } from "@deliverr/ui-facility/lib-facility/components/modals/DamagedProductTicketSuccessModal";
import { DamagedProductModal } from "./DamagedProductModal";

export const damagedProductModalMap: Record<DamagedProductModal, FC<any>> = {
  [DamagedProductModal.DAMAGED_PRODUCT_SUCCESS]: DamagedProductTicketSuccessModal,
};
